var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col md:flex-row items-center justify-around"},[_c('a-spin',{attrs:{"spinning":_vm.isLoading}},[_c('div',{staticClass:"flex justify-center"},[_c('business-registration-email-validation-icon',{staticClass:"company__icon m-4"})],1),_c('validation-observer',{attrs:{"slim":"","tag":"div"}},[_c('text-input',{attrs:{"setup":{
          'func': _vm.inputConfigSetup,
          'args': {
            'model': _vm.companyData,
            'key': 'code',
            'prefix': 'company_registration_',
            'validation': 'required',
          },
        }}}),_c('div',[_c('checkbox-input',{attrs:{"setup":{
            'func': _vm.onChangeAgree,
            'args': {
              'model': _vm.dataAgree,
              'key': 'oferta',
              'prefix': 'company_registration_',
            },
          }}}),_c('checkbox-input',{attrs:{"setup":{
            'func': _vm.onChangeAgree,
            'args': {
              'model': _vm.dataAgree,
              'key': 'agree',
              'prefix': 'company_registration_',
            },
          }}})],1),_c('div',{staticClass:"flex flex-row items-center justify-end mt-5"},[_c('a-button',{staticClass:"mr-2",on:{"click":_vm.backStep}},[_vm._v(" "+_vm._s(_vm.$t('company_registration_button_back'))+" ")]),_c('a-button',{attrs:{"type":"primary","disabled":_vm.companyData.code.length === 0 || (!_vm.dataAgree.agree || !_vm.dataAgree.oferta)},on:{"click":_vm.onNextButtonClick}},[_vm._v(" "+_vm._s(_vm.$t('company_registration_button_next'))+" ")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }